import { Injectable } from '@angular/core';
import { ApplicationModel } from '@ups/xplat/api/dto';
import { JobsService } from './jobs-service';

@Injectable({
  providedIn: 'root',
})
export class CountriesResolver {
  constructor(
    private jobsService: JobsService,
    private applicationModel: ApplicationModel
  ) {}

  load(): Promise<typeof this.applicationModel.countries> {
    if (this.applicationModel.countries.length === 0) {
      return this.jobsService
        .getFullCountries()
        .then(
          (data: { Data: typeof this.applicationModel.countries }) =>
            (this.applicationModel.countries = data.Data)
        );
    }

    return Promise.resolve(this.applicationModel.countries);
  }
}
